/**
 * Link from a pool to the item list's query surface, set up to add the
 * results to that pool and come back. Replaces the retired
 * PoolItemFilterModal (DEP-034): finding items for a pool is the
 * same query, with the same verbs, as finding items anywhere else.
 *
 * Read on the other end by QueryResultActions (`addToPool`, `returnTo`).
 */
export function poolQueryLink(poolId: string, returnTo: string): string {
  const params = new URLSearchParams({ addToPool: poolId, returnTo });
  return `/prioritization/items?${params.toString()}`;
}
